import { useMutation, useQueryClient } from '@tanstack/react-query';

import { mediaApi } from '../api/media-api';

import { mediaKeys } from './media-keys';

/** 409 RESOURCE_IN_USE while a product or variant references the file; the caller renders it. */
export function useDeleteMedia() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => mediaApi.remove(id),
    meta: { successMessage: 'media:toasts.deleted', silentError: true },
    onSuccess: (_void, id) => {
      queryClient.removeQueries({ queryKey: mediaKeys.detail(id) });
      return queryClient.invalidateQueries({ queryKey: mediaKeys.lists() });
    },
  });
}
